"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import { RegionalPageBottomLink } from "./RegionalPageBottomLink";

export function Amenities({ headingText = "Amenities" }) {
  return (
    <Block className={"section_amenities"} tag={"div"}>
      <Block tag={"div"}>
        <Block className={"margin-bottom margin-medium"} tag={"div"}>
          <Block className={"heading-style-h6 text-color-blue"} tag={"div"}>
            {headingText}
          </Block>
        </Block>
        <Block className={"div-block-58"} tag={"div"}>
          <RegionalPageBottomLink />
          <RegionalPageBottomLink />
          <RegionalPageBottomLink />
          <RegionalPageBottomLink />
          <RegionalPageBottomLink />
          <RegionalPageBottomLink />
        </Block>
      </Block>
    </Block>
  );
}
